export default "__VITE_ASSET__cb581469__"